<div class="loader-wrapper" [style.display]="(coreService.isLoading$ | async) ? 'flex' : 'none'">
  <span class="loader"></span>
</div>